import ACQueryBuilder from "./modules/ac-query-builder";
import Segments from "./modules/segments";
import WhitelistedUrlParams from "./modules/segments/whitelisted-url-params";
import $ from 'jquery';
import ResetFilters from "./modules/reset-filters";
import { ActiveFilters } from "./modules/active-filters";
import { getConfiguredFilterTypes } from "./types/functions";
import { initJqueryDateYearScroller } from "./plugin/jquery-date-year-scroller";
initJqueryDateYearScroller();
AdminColumns.ActiveFilters = new ActiveFilters();
AdminColumns.ResetFilters = new ResetFilters(AdminColumns.ActiveFilters);
document.addEventListener('DOMContentLoaded', function () {
    $('[name="acp_filter_action"], #post-query-submit').addClass('ac-search-button');
    if (AC.layout && document.getElementById('ac-s') && ac_search.filters.length) {
        AdminColumns.Search = new ACQueryBuilder(document.getElementById('ac-s'), ac_search, getConfiguredFilterTypes());
        AdminColumns.Search.init();
        if (document.querySelector('.ac-segments')) {
            AdminColumns.Segments = new Segments(AdminColumns.Table, AdminColumns.Search, ACP_Sorting, new WhitelistedUrlParams(document.querySelector('#ac-s')));
        }
        AdminColumns.ActiveFilters.refresh();
    }
});
document.addEventListener('AC_Search_State_Change', function () {
    AdminColumns.ActiveFilters.refresh();
});
